import script from "./ServicesSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesSelection.vue?vue&type=script&setup=true&lang=js"

import "./ServicesSelection.vue?vue&type=style&index=0&id=693feeb0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/hairwizard/hairwizard/hwappointments/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-693feeb0"]])

export default __exports__